import * as url from "../../helpers/url_helper"
import { APIClient } from "../../helpers/api_helper"

const api = new APIClient()

export const getAllRegionsApi = () => api.get(url.GET_ALL_REGIONS_LIST)
